import {
  Text,
  View,
  Image,
  Stop,
  Rect,
  Svg,
  Defs,
  Font,
  StyleSheet,
  LinearGradient,
  Page,
} from "@react-pdf/renderer";

const HorizontalProduct = (props) => {
  const {
    element,
    bgColor,
    bgColorTwo,
    userLogo,
    fontColor,
    previewColor,
    withoutlogo,
    withoutlogoBasd64,
  } = props;

  Font.register({
    family: "NexaLight",
    src: "/../assets/fonts/NexaLight.otf",
  });
  Font.register({
    family: "NexaBold",
    src: "/../assets/fonts/NexaBold.otf",
  });
  Font.register({
    family: "UniversoBold",
    src: "/../assets/fonts/UniversoBold.ttf",
  });

  const styles = StyleSheet.create({
    logo: {
      maxWidth: 100,
      maxHeight: 70
    },
    colletionBox: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    productName: {
      fontFamily: "UniversoBold",
      display: "flex",
      textAlign: "right",
      fontSize: "22pt",
      marginBottom: 10,
      color: fontColor,
    },
    lineBox: {
      display: "flex",
      alignItems: "flex-end",
    },
    line: {
      width: "10%",
      height: 1,
      marginTop: 15,
      backgroundColor: fontColor,
      marginBottom: 15,
    },
    finish: {
      fontFamily: "NexaBold",
      display: "flex",
      textAlign: "right",
      marginBottom: 10,
    },
    sizeBox: {
      display: "flex",
      textAlign: "right",
      marginBottom: 10,
    },
    detailBox: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-end",
    },
    productBox: {
      height: 495,
      display: "flex",
      flexDirection: "row",
      margin: 50,
    },
    firstBox: {
      width: "50%",
      display: "flex",
      justifyContent: "flex-start",
      gap: 5,
    },
    secondBox: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },

    image: {
      width: "100%",
      height: "100%",
    },

    imageFaceBox: {
      // width: "30%",
      display: "flex",
      gap: 5,
    },

    textBold: {
      fontFamily: "NexaBold",
      // letterSpacing: "2px",
      fontSize: 14,
      fontWeight: "100px",
      color: fontColor,
    },
    textLight: {
      fontFamily: "NexaLight",
      // letterSpacing: "1px",
      fontSize: 12,
      color: fontColor,
    },
    textThickness: {
      fontFamily: "NexaLight",
      // letterSpacing: "2px",
      fontSize: 10,
      color: fontColor,
    },
    previewname: {
      display: "flex",
      fontFamily: "UniversoBold",
      flexDirection: "row",
      position: "absolute",
      fontSize: 20,
      bottom: 59,
      left: 85,
      color: previewColor,
    },
    previewsize: {
      fontFamily: "NexaLight",
      fontSize: 19,
      color: previewColor,
    },
    previewBoxDetail: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      position: "absolute",
      bottom: 40,
      left: 85,
    },
    previewSizeBox: {
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
    },
    previewImage: {
      padding: 20,
    },
  });

  return (
    <View>
      <View style={{ position: "relative" }}>
        <Svg viewBox="0 0 842 595" width="100%" height="595" fixed>
          <Defs>
            <LinearGradient id="myLinearGradient" x1="1" y1="1.5" x2="0" y2="0">
              <Stop offset="0%" stopColor={bgColorTwo} />
              <Stop offset="100%" stopColor={bgColor} />
            </LinearGradient>
          </Defs>
          <Rect
            fill="url('#myLinearGradient')"
            x="0"
            y="0"
            width="100%"
            height="595"
          />
        </Svg>
        <View style={{ position: "absolute", width: "100%" }}>
          <View style={styles.productBox}>
            <View
              style={{
                ...styles.firstBox,
                flexDirection: element.isVertical ? "row" : "column",
              }}
            >
              <View>
                <Image
                  cache={false}
                  src={element.image}
                  style={{
                    height: element.isVertical ? 495 : 370,
                    width: element.isVertical ? 247.5 : 370,
                  }}
                />
              </View>
              <View
                style={{
                  ...styles.imageFaceBox,
                  flexDirection: element.isVertical ? "column" : "row",
                  width: element.isVertical ? 80.83 : 370,
                }}
              >
                {element.product.face_one ? (
                  <Image
                    cache={false}
                    style={{
                      height: element.isVertical ? 161.66 : 123.33,
                      width: element.isVertical ? 80.83 : 123.33,
                    }}
                    src={element.product.face_one}
                  />
                ):null}
                {element.product.face_two ? (
                  <Image
                    cache={false}
                    style={{
                      height: element.isVertical ? 161.66 : 123.33,
                      width: element.isVertical ? 80.83 : 123.33,
                    }}
                    src={element.product.face_two}
                  />
                ):null}
                {element.product.face_three ? (
                  <Image
                    cache={false}
                    style={{
                      height: element.isVertical ? 161.66 : 123.33,
                      width: element.isVertical ? 80.83 : 123.33,
                    }}
                    src={element.product.face_three}
                  />
                ):null}
              </View>
              {/* <View style={styles.imageFaceBox}>
                {element.product.face_four && (
                  <Image
                    style={{height: element.isVertical ? 161.66: 123.33, width: element.isVertical ? 80.83: 123.33}}
                    src={element.product.face_four}
                  />
                )}
                {element.product.face_five && (
                  <Image
                    style={{height: element.isVertical ? 161.66: 123.33, width: element.isVertical ? 80.83: 123.33}}
                    src={element.product.face_five}
                  />
                )}
                {element.product.face_six && (
                  <Image
                    style={{height: element.isVertical ? 161.66: 123.33, width: element.isVertical ? 80.83: 123.33}}
                    src={element.product.face_six}
                  />
                )}
              </View> */}
            </View>
            <View style={styles.secondBox}>
              <View style={styles.colletionBox}>
                {withoutlogo && withoutlogoBasd64 ? (
                  <Image
                    style={{ maxWidth: 150, maxHeight: 100 }}
                    cache={false}
                    src={withoutlogoBasd64}
                  />
                ):null}
                {!withoutlogo ? (
                  <Image
                    cache={false}
                    style={{ maxWidth: 150, maxHeight: 100 }}
                    src={
                      userLogo == "LOGO"
                        ? element.user_logo
                        : element.user_dark_logo
                    }
                  />
                ):null}
              </View>
              <View>
                <Text style={styles.productName}>{element.product.name}</Text>
                <View style={styles.lineBox}>
                  <View style={styles.line} />
                </View>
                <View style={styles.finish}>
                  <Text style={{ ...styles.textLight, fontSize: "15pt" }}>
                    Surface
                  </Text>
                  <Text
                    style={{
                      ...styles.textBold,
                      fontSize: "19pt",
                      marginTop: 5,
                    }}
                  >
                    {element.series}
                  </Text>
                </View>
                <View style={styles.lineBox}>
                  <View style={styles.line} />
                </View>
                {element.sizes.length === 2 ? (
                  <View style={styles.sizeBox}>
                    <view
                      style={{
                        flexDirection: "row",
                        alignSelf: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      {element.sizes.length > 0 ?
                        element.sizes.map((size, key) => {
                          return (
                            <View
                              // style={{paddingBottom: "10px"}}
                              key={key}
                            >
                              <View style={styles.detailBox}>
                                <Text
                                  style={{
                                    ...styles.textBold,
                                    fontSize: "16pt",
                                  }}
                                >
                                  {size.name}
                                </Text>
                                <Text
                                  style={{
                                    ...styles.textLight,
                                    fontSize: "16pt",
                                  }}
                                >
                                  {size.unit}
                                </Text>
                                {key < element.sizes.length - 1 ? (
                                  <Text
                                    style={{
                                      verticalAlign: "super",
                                      color: fontColor,
                                      margin: 4,
                                      paddingTop: 4,
                                      fontSize: 12,
                                    }}
                                  >
                                    {" "}
                                    |{" "}
                                  </Text>
                                ):null}
                              </View>
                            </View>
                          );
                        }):null}
                    </view>
                    {element.sizes.length > 0 ? (
                      <View
                        style={{
                          flexDirection: "row",
                          alignSelf: "flex-end",
                          alignItems: "center",
                          paddingBottom: "15px",
                        }}
                      >
                        <Text style={{ ...styles.textBold, fontSize: "16pt" }}>
                          {element.sizes[0].thickness}
                        </Text>
                        <Text style={{ ...styles.textLight, fontSize: "16pt" }}>
                          {element.sizes[0].unit}
                        </Text>
                        <Text style={{ ...styles.textLight, fontSize: "16pt" }}>
                          &nbsp;Thickness
                        </Text>
                      </View>
                    ):null}
                    <View style={styles.detailBox}>
                      <Text style={{ ...styles.textBold, fontSize: "16pt" }}>
                        Random
                      </Text>
                      <Text style={{ ...styles.textLight, fontSize: "16pt" }}>
                        &nbsp;Design
                      </Text>
                    </View>
                  </View>
                ) : (
                  <View style={styles.sizeBox}>
                    {element.sizes.length > 0 ?
                      element.sizes.map((size, key) => {
                        return (
                          <View
                            style={{ display: "flex", paddingBottom: "10px" }}
                            key={key}
                          >
                            <View style={styles.detailBox}>
                              <Text
                                style={{ ...styles.textBold, fontSize: "16pt" }}
                              >
                                {size.name}
                              </Text>
                              <Text
                                style={{
                                  ...styles.textLight,
                                  fontSize: "16pt",
                                }}
                              >
                                {size.unit}
                              </Text>
                              <Text
                                style={{
                                  verticalAlign: "super",
                                  color: fontColor,
                                  margin: 4,
                                  paddingTop: 4,
                                  fontSize: 12,
                                }}
                              >
                                {" "}
                                |{" "}
                              </Text>
                              <Text
                                style={{ ...styles.textBold, fontSize: "16pt" }}
                              >
                                {size.thickness}
                              </Text>
                              <Text
                                style={{
                                  ...styles.textLight,
                                  fontSize: "16pt",
                                }}
                              >
                                {size.unit}
                              </Text>
                              <Text
                                style={{
                                  ...styles.textLight,
                                  fontSize: "16pt",
                                }}
                              >
                                &nbsp;Thickness
                              </Text>
                            </View>
                          </View>
                        );
                      }):null}
                    <View style={styles.detailBox}>
                      <Text style={{ ...styles.textBold, fontSize: "16pt" }}>
                        Random
                      </Text>
                      <Text style={{ ...styles.textLight, fontSize: "16pt" }}>
                        &nbsp;Design
                      </Text>
                    </View>
                  </View>
                )}
                <View style={styles.lineBox}>
                  <View style={styles.line} />
                </View>
                {element.website && element.colletion_image ? (
                  <View style={{ ...styles.colletionBox }}>
                    <Image
                      style={styles.logo}
                      cache={false}
                      src={element.colletion_image}
                    />
                  </View>
                ):null}
              </View>
              <View style={{ ...styles.colletionBox }}>
                {!element.website && element.colletion_image ? (
                  <Image
                    style={styles.logo}
                    cache={false}
                    src={element.colletion_image}
                  />
                ):null}
                {element.website && !withoutlogo ? (
                  <Text style={{ ...styles.textLight, fontSize: "12pt" }}>
                    {element.website}
                  </Text>
                ):null}
              </View>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};
export default HorizontalProduct;
